<template>
  <div class="page-sidebar-nav hide-for-print" v-if="current">
    <component :countriesRegime="this.countriesRegime" :is="current"></component>
  </div><!-- /.compare-attributes-nav -->
</template>

<script>
import WorldMap from './WorldMap'
import CompareAttributes from './CompareAttributes'
import CompareCountriesRegions from './CompareCountriesRegions'
import CountryRegionProfile from './CountryRegionProfile'

import {EventBus} from '@/event-bus.js'

export default {
  name: 'page-sidebar-nav',
  components: {
    WorldMap,
    CompareAttributes,
    CompareCountriesRegions,
    CountryRegionProfile
  },
  props: [ 'countriesRegime' ],
  created () {
    EventBus.$on('sidebar-nav', (page) => {
      switch (page) {
        case 'CompareAttributes' :
          this.current = CompareAttributes
          break
        case 'WorldMap' :
          this.current = WorldMap
          break
        case 'CountryRegionProfile' :
          this.current = CountryRegionProfile
          break
        case 'CompareCountriesRegions' :
          this.current = CompareCountriesRegions
          break
        default :
          this.current = false
          break
      }
    })
    EventBus.$on('tooltip.close', () => {
      this.close()
    })
  },
  destroyed () {
    // Remove event handlers
    EventBus.$off('sidebar-nav')
  },
  data () {
    return {
      current: CompareAttributes
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/navigation/PageSidebarNavigation/Nav.vue